import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';

import Isvg from 'react-inlinesvg';

import Slider from "react-slick";

import Range from 'rc-slider/lib/Range';
import Tooltip from 'rc-tooltip';

import 'rc-slider/assets/index.css';

import Switch from 'react-ios-switch';
import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';

class ProductsPage extends Component {
    constructor(props) {
        super(props);

        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.handleDeletePrompt = this.handleDeletePrompt.bind(this);

        this.state = {
            products: [],
        };
    }


    componentDidMount() {
        this.props.handleLoader(true);
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });



        this.props.socketIOClient.on('products', (data) => {
            //console.log(data);
            this.props.handleLoader(null);
            this.setState({
                products: data
            });
        });


        this.props.socketIOClient.emit('products', {});
    }

    componentWillUnmount(){ if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("products");
    }

    handleDeletePrompt(answer, val) {
       // console.log(val);
        if (answer) {
            this.props.socketIOClient.emit('deleteProduct', { product: val });
            this.props.openDeletePrompt(null, null);

        } else {
            this.props.openDeletePrompt(null, null);
        }
    }



    render() {

        return (
            <div className="content">
            {

                                (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />
      
              }
                <div className="panel panel-list">
                    <div>

                        <div className="title">
                            <h1>{this.props.translate('Products')}</h1>

                            <div className="button-wrap">
                                <Link to='/products/new' className="button" >{this.props.translate('Add new product')}</Link>
                            </div>
                            <h6>{this.props.translate('List of products')}</h6>



                        </div>


                        <div className="table">
                            <table>
                                {/*<tr>
                                    <th>{this.props.translate('Image')}</th>
                                    <th>{this.props.translate('Title')}</th>
                                    <th>{this.props.translate('Alias')}</th>
                                    <th>{this.props.translate('Category')}</th>
                                    <th className="action-head">{this.props.translate('Action')}</th>
                                </tr>
                                */}
                                {
                                    this.state.products.map((product) => {
                                        return (
                                            <tr>
                                                <td>{product.title}</td>
                                                <td>{product.alias}</td>
                                                <td>{product.breadcrumb}</td>

                                                <td className="action">
                                                    <Link to={`/products/${product._id}`} className="button" ><i className="mdi mdi-pencil"></i> </Link>
                                                    <button className="button" onClick={() => this.props.openDeletePrompt(product._id, this.handleDeletePrompt)}><i className="mdi mdi-delete"></i> </button>
                                                </td>
                                            </tr>


                                        )
                                    }
                                    )}

                            </table>

                        </div>


                    </div>

                </div>


            </div>
        );
    }
}

export default PageWithLayout(ProductsPage);


// WEBPACK FOOTER //
// ./src/views/productsPage.js